import * as React from 'react';

enum ExerciseType {
  RUGBY_UNION = "Rugby Union",
  RUGBY_LEAGUE = "Rugby League",
  FOOTBALL = "Football",
  CRICKET = "Cricket",
  SCHOOLS = "Schools"
}

type DrillList = {
  [key in ExerciseType]: DrillObject[]
}


type DrillObject = {
  title: string;
  optGroup: string;
  component: React.LazyExoticComponent<() => JSX.Element>
}

const Drills: DrillList = {
  "Rugby Union": [
    {
      title: 'Introduction',
      optGroup: '',
      component: React.lazy(() => import('./RugbyUnion/Introduction'))
    },
    {
      title: 'Drill 1',
      component: React.lazy(() => import('./RugbyUnion/One')),
      optGroup: 'Warmup for Rugby Union Players'
    },
    {
      title: 'Drill 2',
      component: React.lazy(() => import('./RugbyUnion/Two')),
      optGroup: 'Warmup for Rugby Union Players'
    },
    {
      title: 'Drill 3',
      component: React.lazy(() => import('./RugbyUnion/Three')),
      optGroup: 'Warmup for Rugby Union Players'
    },
    {
      title: 'Drill 4',
      component: React.lazy(() => import('./RugbyUnion/Four')),
      optGroup: 'Warmup for Rugby Union Players'
    },
    {
      title: 'Drill 1',
      component: React.lazy(() => import('./RugbyUnion/Five')),
      optGroup: 'Handling Drills using the TRS'
    },
    {
      title: 'Drill 2',
      component: React.lazy(() => import('./RugbyUnion/Six')),
      optGroup: 'Handling Drills using the TRS'
    },
    {
      title: 'Drill 3',
      component: React.lazy(() => import('./RugbyUnion/Seven')),
      optGroup: 'Handling Drills using the TRS'
    },
    {
      title: 'Drill 4',
      component: React.lazy(() => import('./RugbyUnion/Eight')),
      optGroup: 'Handling Drills using the TRS'
    },
    {
      title: 'Drill 5',
      component: React.lazy(() => import('./RugbyUnion/Nine')),
      optGroup: 'Handling Drills using the TRS'
    },
    {
      title: 'Drill 6',
      component: React.lazy(() => import('./RugbyUnion/Ten')),
      optGroup: 'Handling Drills using the TRS'
    },
    {
      title: 'Drill 7',
      component: React.lazy(() => import('./RugbyUnion/Eleven')),
      optGroup: 'Handling Drills using the TRS'
    },
    {
      title: 'Drill 8',
      component: React.lazy(() => import('./RugbyUnion/Twelve')),
      optGroup: 'Handling Drills using the TRS'
    },
    {
      title: 'Drill 1',
      component: React.lazy(() => import('./RugbyUnion/Thirteen')),
      optGroup: 'Tackling Drills using the TRS'
    },
    {
      title: 'Drill 2',
      component: React.lazy(() => import('./RugbyUnion/Fourteen')),
      optGroup: 'Tackling Drills using the TRS'
    },
    {
      title: 'Drill 1',
      component: React.lazy(() => import('./RugbyUnion/Fifteen')),
      optGroup: 'Kicking Drills using the TRS'
    },
    {
      title: 'Drill 2',
      component: React.lazy(() => import('./RugbyUnion/Sixteen')),
      optGroup: 'Kicking Drills using the TRS'
    },
    {
      title: 'Drill 1',
      component: React.lazy(() => import('./RugbyUnion/Seventeen')),
      optGroup: 'Reading the Play using the TRS'
    },
    {
      title: 'Drill 2',
      component: React.lazy(() => import('./RugbyUnion/Eighteen')),
      optGroup: 'Reading the Play using the TRS'
    }
  ],
  // Rugby League verified OK.
  "Rugby League": [
    {
      title: 'Introduction',
      component: React.lazy(() => import('./RugbyLeague/Introduction')),
      optGroup: ''
    },
    {
      title: 'Drill 1',
      component: React.lazy(() => import('./RugbyLeague/One')),
      optGroup: 'Warmup for Rugby League Players'
    },
    {
      title: 'Drill 2',
      component: React.lazy(() => import('./RugbyLeague/Two')),
      optGroup: 'Warmup for Rugby League Players'
    },
    {
      title: 'Drill 3',
      component: React.lazy(() => import('./RugbyLeague/Three')),
      optGroup: 'Warmup for Rugby League Players'
    },
    {
      title: 'Drill 4',
      component: React.lazy(() => import('./RugbyLeague/Four')),
      optGroup: 'Warmup for Rugby League Players'
    },
    {
      title: 'Drill 1',
      component: React.lazy(() => import('./RugbyLeague/Five')),
      optGroup: 'Handling Drills using the TRS'
    },
    {
      title: 'Drill 2',
      component: React.lazy(() => import('./RugbyLeague/Six')),
      optGroup: 'Handling Drills using the TRS'
    },
    {
      title: 'Drill 3',
      component: React.lazy(() => import('./RugbyLeague/Seven')),
      optGroup: 'Handling Drills using the TRS'
    },
    {
      title: 'Drill 4',
      component: React.lazy(() => import('./RugbyLeague/Eight')),
      optGroup: 'Handling Drills using the TRS'
    },
    {
      title: 'Drill 5',
      component: React.lazy(() => import('./RugbyLeague/Nine')),
      optGroup: 'Handling Drills using the TRS'
    },
    {
      title: 'Drill 6',
      component: React.lazy(() => import('./RugbyLeague/Ten')),
      optGroup: 'Handling Drills using the TRS'
    },
    {
      title: 'Drill 7',
      component: React.lazy(() => import('./RugbyLeague/Eleven')),
      optGroup: 'Handling Drills using the TRS'
    },
    {
      title: 'Drill 8',
      component: React.lazy(() => import('./RugbyLeague/Eighteen')),
      optGroup: 'Handling Drills using the TRS',
    },
    {
      title: 'Drill 1',
      component: React.lazy(() => import('./RugbyLeague/Twelve')),
      optGroup: 'Tackling Drills using the TRS'
    },
    {
      title: 'Drill 2',
      component: React.lazy(() => import('./RugbyLeague/Thirteen')),
      optGroup: 'Tackling Drills using the TRS'
    },
    {
      title: 'Drill 1',
      component: React.lazy(() => import('./RugbyLeague/Fourteen')),
      optGroup: 'Kicking Drills using the TRS'
    },
    {
      title: 'Drill 2',
      component: React.lazy(() => import('./RugbyLeague/Fifteen')),
      optGroup: 'Kicking Drills using the TRS'
    },
    {
      title: 'Drill 1',
      component: React.lazy(() => import('./RugbyLeague/Sixteen')),
      optGroup: 'Reading the Play using the TRS'
    },
    {
      title: 'Drill 2',
      component: React.lazy(() => import('./RugbyLeague/Seventeen')),
      optGroup: 'Reading the Play using the TRS'
    }
  ],
  "Football": [
    {
      title: 'Introduction',
      component: React.lazy(() => import('./Football/Introduction')),
      optGroup: ''
    },
    {
      title: 'Drill 1',
      component: React.lazy(() => import('./Football/One')),
      optGroup: 'Warmup for Goalkeepers'
    },
    {
      title: 'Drill 2',
      component: React.lazy(() => import('./Football/Two')),
      optGroup: 'Warmup for Goalkeepers'
    },
    {
      title: 'Drill 3',
      component: React.lazy(() => import('./Football/Three')),
      optGroup: 'Warmup for Goalkeepers'
    },
    {
      title: 'Drill 1',
      component: React.lazy(() => import('./Football/Four')),
      optGroup: 'Warmup for non-Goalkeepers'
    },
    {
      title: 'Drill 2',
      component: React.lazy(() => import('./Football/Five')),
      optGroup: 'Warmup for non-Goalkeepers'
    },
    {
      title: 'Drill 3',
      component: React.lazy(() => import('./Football/Six')),
      optGroup: 'Warmup for non-Goalkeepers'
    },
    {
      title: 'Drill 4',
      component: React.lazy(() => import('./Football/Seven')),
      optGroup: 'Warmup for non-Goalkeepers'
    },
    {
      title: 'General Reaction for all Players',
      component: React.lazy(() => import('./Football/Eight')),
      optGroup: 'Warmup for all Players'
    },
    {
      title: 'Drill 1',
      component: React.lazy(() => import('./Football/Nine')),
      optGroup: 'Drills with the TRS'
    },
    {
      title: 'Drill 2',
      component: React.lazy(() => import('./Football/Ten')),
      optGroup: 'Drills with the TRS'
    },
    {
      title: 'Drill 3',
      component: React.lazy(() => import('./Football/Eleven')),
      optGroup: 'Drills with the TRS'
    },
    {
      title: 'Drill 4',
      component: React.lazy(() => import('./Football/Twelve')),
      optGroup: 'Drills with the TRS'
    },
    {
      title: 'Drill 5',
      component: React.lazy(() => import('./Football/Thirteen')),
      optGroup: 'Drills with the TRS'
    },
    {
      title: 'Drill 6',
      component: React.lazy(() => import('./Football/Fourteen')),
      optGroup: 'Drills with the TRS'
    },
    {
      title: 'Drill 7',
      component: React.lazy(() => import('./Football/Fifteen')),
      optGroup: 'Drills with the TRS'
    },
    {
      title: 'Drill 8',
      component: React.lazy(() => import('./Football/Sixteen')),
      optGroup: 'Drills with the TRS'
    },
    {
      title: 'Drill 9',
      component: React.lazy(() => import('./Football/Seventeen')),
      optGroup: 'Drills with the TRS'
    },
    {
      title: 'Drill 10',
      component: React.lazy(() => import('./Football/Eighteen')),
      optGroup: 'Drills with the TRS'
    },
    {
      title: 'Drill 11',
      component: React.lazy(() => import('./Football/Nineteen')),
      optGroup: 'Drills with the TRS'
    },
    {
      title: 'Drill 12',
      component: React.lazy(() => import('./Football/Twenty')),
      optGroup: 'Drills with the TRS'
    },
    {
      title: 'Drill 13',
      component: React.lazy(() => import('./Football/TwentyOne')),
      optGroup: 'Drills with the TRS'
    },
    {
      title: 'Drill 14',
      component: React.lazy(() => import('./Football/TwentyTwo')),
      optGroup: 'Drills with the TRS'
    }

  ],
  "Cricket": [
    {
      title: 'Introduction',
      component: React.lazy(() => import('./Cricket/Introduction')),
      optGroup: ''
    },
    {
      title: 'Drill 1',
      component: React.lazy(() => import('./Cricket/One')),
      optGroup: 'Warmup for Fielders'
    },
    {
      title: 'Drill 2',
      component: React.lazy(() => import('./Cricket/Two')),
      optGroup: 'Warmup for Fielders'
    },
    {
      title: 'Drill 3',
      component: React.lazy(() => import('./Cricket/Three')),
      optGroup: 'Warmup for Fielders'
    },
    {
      title: 'Drill 1',
      component: React.lazy(() => import('./Cricket/Four')),
      optGroup: 'Outfielding Drill using the TRS'
    },
    {
      title: 'Drill 2',
      component: React.lazy(() => import('./Cricket/Five')),
      optGroup: 'Outfielding Drill using the TRS'
    },
    {
      title: 'Drill 3',
      component: React.lazy(() => import('./Cricket/Six')),
      optGroup: 'Outfielding Drill using the TRS'
    },
    {
      title: 'Drill 1',
      component: React.lazy(() => import('./Cricket/Seven')),
      optGroup: 'Slips Fielding Drill Using the TRS'
    },
    {
      title: 'Drill 2',
      component: React.lazy(() => import('./Cricket/Eight')),
      optGroup: 'Slips Fielding Drill Using the TRS'
    },
    {
      title: 'Drill 3',
      component: React.lazy(() => import('./Cricket/Nine')),
      optGroup: 'Slips Fielding Drill Using the TRS'
    },
    {
      title: 'Drill 1',
      component: React.lazy(() => import('./Cricket/Ten')),
      optGroup: 'Wicket Keeping Drill Using the TRS'
    },
    {
      title: 'Drill 2',
      component: React.lazy(() => import('./Cricket/Eleven')),
      optGroup: 'Wicket Keeping Drill Using the TRS'
    },
    {
      title: 'Drill 3',
      component: React.lazy(() => import('./Cricket/Twelve')),
      optGroup: 'Wicket Keeping Drill Using the TRS'
    },
    {
      title: 'Drill 1',
      component: React.lazy(() => import('./Cricket/Thirteen')),
      optGroup: 'Batting Drill using the TRS'
    },
    {
      title: 'Drill 1',
      component: React.lazy(() => import('./Cricket/Fourteen')),
      optGroup: 'Bowling Drill using the TRS'
    }
  ],
  "Schools": [
    {
      title: 'Introduction',
      component: React.lazy(() => import('./Schools/Introduction')),
      optGroup: ''
    },
    {
      title: 'Drill 1 - Rolling Ball',
      component: React.lazy(() => import('./Schools/One')),
      optGroup: ''
    },
    {
      title: 'Drill 2 - Bouncing Ball',
      component: React.lazy(() => import('./Schools/Two')),
      optGroup: ''
    },
    {
      title: 'Drill 3 - Over Screen Catching',
      component: React.lazy(() => import('./Schools/Three')),
      optGroup: ''
    },
    {
      title: 'Drill 4 - Through Screen Catching',
      component: React.lazy(() => import('./Schools/Four')),
      optGroup: ''
    },
    {
      title: 'Drill 5 - All Skills Together',
      component: React.lazy(() => import('./Schools/Five')),
      optGroup: ''
    },
    {
      title: 'Drill 6 - Legs, Feet & Eye Co-ordination',
      component: React.lazy(() => import('./Schools/Six')),
      optGroup: ''
    },
    {
      title: 'Drill 7 - Through the Screen',
      component: React.lazy(() => import('./Schools/Seven')),
      optGroup: ''
    },
  ]
};

export {
  ExerciseType,
  DrillList,
  DrillObject,
  Drills
};
